import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RiepilogoPrenotazioniGiornoResponse, RiepilogoScrivaniaStatus, PrenotazioneScrivaniaRequest, RicercaPrenotazioniRequest, RicercaPrenotazioniResponse, Prenotazione} from '../core/core.component';
import { Http, Headers} from '@angular/http'; 
import { AppConstants } from '../core/app.constants';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UfficioService 
{
  private pattern: string = "yyyy-MM-dd";

  constructor(private http: Http, private datePipe: DatePipe) { }

  scrivaniaDetailStatus: Subject<any> = new Subject();
  refreshEvent: Subject<any> = new Subject();
  refreshProspectEvent: Subject<any> = new Subject();    
  
  getScrivaniaDetailStatus() : Observable<any> {
      return this.scrivaniaDetailStatus.asObservable();
  }
  
  openScrivaniaDetail(date: Date, statoScrivania:RiepilogoScrivaniaStatus, prenotazione:Prenotazione) {
      let data = date != null && typeof(date) != 'undefined' ? date : null;
      this.scrivaniaDetailStatus.next({status: "open", date: data, stato: statoScrivania, prenotazione: prenotazione});
  }

  closeScrivaniaDetail() {
      this.scrivaniaDetailStatus.next({status: "close"});
  }

  getRefreshProspectEvent() : Observable<string> {
    return this.refreshProspectEvent.asObservable();
  }    

  fireRefreshProspectEvent() {
      this.refreshProspectEvent.next("reload-detail");
  }  

  getRefreshEvent() : Observable<string> {
    return this.refreshEvent.asObservable();
  }

  fireRefreshEvent() {
      this.refreshEvent.next();
  }

  riepilogoScrivanieGiorno(srmToken, giorno): Observable<RiepilogoPrenotazioniGiornoResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/ufficio/riepilogo/"+this.datePipe.transform(giorno, this.pattern);
        url = AppConstants.urlForNoCache(url);
        
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }
/*
  dettaglioScrivania(srmToken, idScrivania, giorno): Observable<RiepilogoPrenotazioniGiornoResponse>{
        var url = environment.REST_SERVICE_BASE_URL + "/ufficio/riepilogo/"+idScrivania+"/"+this.datePipe.transform(giorno, this.pattern);
        url = AppConstants.urlForNoCache(url);
        
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }
*/
  prenotaScrivania(srmToken, data:PrenotazioneScrivaniaRequest){
    var url = environment.REST_SERVICE_BASE_URL + "/ufficio/prenota"; 
    url = AppConstants.urlForNoCache(url);
    
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    
    return this.http.post(url, data, {headers: headers}).map((responseData) => responseData.json());
  }

  liberaScrivania(srmToken, idPrenotazione:number){
    var url = environment.REST_SERVICE_BASE_URL + "/ufficio/cancella/"+idPrenotazione; 
    url = AppConstants.urlForNoCache(url);
    
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    
    return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
  }

  ricercaPrenotazioni(srmToken, request: RicercaPrenotazioniRequest): Observable<RicercaPrenotazioniResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/ufficio/ricerca"; 
    url = AppConstants.urlForNoCache(url);

    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.post(url, request, {headers: headers}).map((responseData) => responseData.json());
  }

}


// WEBPACK FOOTER //
// ./src/app/service/ufficio.service.ts